import React from "react"
import { Form, useNavigate } from "react-router-dom"
import {
  Alert,
  Box,
  Button,
  Heading,
  IconButton,
  Input,
  InputGroup,
  InputRightAddon,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react"
import { UserLogin } from "../lib/user"
import { onChange } from "../lib/util"
import GradientBox from "./GradientBox"
import Link from "./Link"
import { GoogleLogin } from "@react-oauth/google"
import { Api } from "../lib/api"
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons"

export default function Login() {
  const api = new Api()
  const [username, setUsername] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [error, setError] = React.useState(null)
  const [success, setSuccess] = React.useState(null)
  const [inputType, setInputType] = React.useState("password")
  const navigate = useNavigate()

  const login = async (event) => {
    event.preventDefault()
    console.log("Logging user in...")
    let success
    try {
      success = await UserLogin(username, password)
    } catch (e) {
      success = false
    }

    if (!success) {
      setPassword("")
      setSuccess(null)
      setError("Login failed")
    } else {
      setError(null)
      setUsername("")
      setPassword("")
      console.log("Login success")
      navigate("/")
    }
  }

  const redirectToRegister = () => {
    navigate("/register")
  }

  const responseMessage = async (response) => {
    console.log(response)
    await api.googleLogin(response.credential, response.clientId)
  }

  const errorMessage = (error) => {
    console.log(error)
    setError(error)
  }

  const toggleVisibility = () => {
    setInputType(inputType === "password" ? "text" : "password")
  }

  return (
    <GradientBox>
      <VStack
        justifyContent="flex-start"
        alignItems="left"
        w="fill-available"
        gap={2}
      >
        <Heading variant="standard">Sign In</Heading>
        <Form onSubmit={login} width="auto">
          <Text variant="subtext">Sign in to your account</Text>
          {error && <Alert status="error">{error}</Alert>}
          {success && <Alert status="success">{success}</Alert>}
          <VStack
            mt={{ base: 3, md: 8 }}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            minWidth="100%"
            spacing="0"
          >
            <Input
              variant="account"
              placeholder="Email"
              autoComplete="username"
              label="Email address"
              value={username}
              onChange={onChange(setUsername)}
              type="email"
              name="email"
              isRequired
            />
            <Text variant="subtext">{error || ""}</Text>
            <InputGroup mt={{ base: 2, md: 6 }} variant="account">
              <Input
                placeholder="Password"
                type={inputType}
                autoComplete="current-password"
                value={password}
                onChange={onChange(setPassword)}
                name="password"
                status={error && "error"}
                isRequired
              />
              <InputRightAddon>
                <Tooltip
                  label={
                    inputType === "password" ? "Show password" : "Hide password"
                  }
                >
                  <IconButton
                    variant="link"
                    icon={
                      inputType === "password" ? <ViewIcon /> : <ViewOffIcon />
                    }
                    onClick={toggleVisibility}
                  />
                </Tooltip>
              </InputRightAddon>
            </InputGroup>
            <Text variant="subtext" mt={{ base: 0, md: 1 }} ml="auto">
              {error || (
                <>
                  {" "}
                  <Link
                    textDecoration="underline"
                    to="/accounts/forgot-password"
                  >
                    Forgot Password?
                  </Link>
                </>
              )}
            </Text>
            <VStack
              mt={8}
              minWidth="100%"
              alignContent="center"
              spacing={{ base: 2, md: 3 }}
            >
              <Button variant="account" type="submit" id="submit">
                Sign In
              </Button>
              <Text variant="subtext"> &mdash; OR &mdash; </Text>
              <GoogleLogin
                onSuccess={responseMessage}
                onError={errorMessage}
                shape="pill"
                text="signin_with"
                context="signin"
                ux_mode="popup"
              />
              {typeof window !== "undefined" &&
              window.location.hostname.startsWith("demo.") ? (
                <Box
                  bg="white"
                  color="Gray.800"
                  p={4}
                  borderRadius="md"
                  textAlign="center"
                  mt={4}
                >
                  Welcome to the Blind Insight demo application.
                </Box>
              ) : (
                <Text variant="subtext" mt={4}>
                  Don{"'"}t have an account?{" "}
                  <Link
                    onClick={redirectToRegister}
                    textDecoration="underline"
                    color="white"
                  >
                    Register here.
                  </Link>
                </Text>
              )}
            </VStack>
          </VStack>
        </Form>
      </VStack>
    </GradientBox>
  )
}
